import lottie from 'lottie-web';
import $ from 'jquery';

class LottieElement {
    private path: string;

    constructor(private element: HTMLElement) {
        this.path = element.getAttribute("data-path");
    }
    init = () => {
        // get inline options
        const loop = (this.element.getAttribute("data-loop") || "true") === "true";
        const autoplay = (this.element.getAttribute("data-autoplay") || "true") === "true";
        const renderer: any = this.element.getAttribute("data-renderer") || "svg";

        // render when modal shown
        const myLottie = lottie.loadAnimation({
            container: this.element, // the dom element that will contain the animation
            renderer,
            loop,
            autoplay,
            path: this.path // the path to the animation json
        });

        // modal
        const modal = this.element.closest(".modal");
        if (modal) {
            $(modal).on("shown.bs.modal", () => {
                // play lottie on modal shown
                myLottie.play();
            });
            $(modal).on("hidden.bs.modal", () => {
                // stop lottie on modal hidden
                myLottie.stop();
            });
        }
    }
}

document.querySelectorAll<HTMLElement>("[data-lottie]").forEach(element => {
    const lottie = new LottieElement(element);
    lottie.init();
});
export default undefined;
